(() => {
  if (customElements.get('tsl-package-quiz')) return;

  const PACKAGES = {
    samduo: { title: 'SAMDUO Nex E6000', capacity: '6,028 kWh opslag · 800 W netgekoppeld', phase: 'Geschikte aansluiting nodig volgens de handleiding', included: 'Batterij en AC-kabel inbegrepen; P1-meter niet inbegrepen' },
    'marstek-p1': {
      capacity: '5,12 kWh opslag',
      phase: 'Geschikt voor 1- en 3-fase',
      included: 'Batterij en P1-meter inbegrepen',
    },
    'marstek-no-p1': {
      capacity: '5,12 kWh opslag',
      phase: 'Geschikt voor 1- en 3-fase',
      included: 'Batterij zonder extra P1-meter',
    },
  };

  Object.assign(PACKAGES, {
  "neo-1f-6": {
    "title": "Sigenergy Neo 1-fase 6 kWh",
    "capacity": "6 kWh opslag · 3 kW",
    "phase": "Voor een 1-faseaansluiting",
    "included": "Neo batterij, controller, sensor en grondmontagekit"
  },
  "neo-1f-8": {
    "title": "Sigenergy Neo 1-fase 8 kWh",
    "capacity": "8 kWh opslag · 4,6 kW",
    "phase": "Voor een 1-faseaansluiting",
    "included": "Neo batterij, controller, sensor en grondmontagekit"
  },
  "neo-1f-12": {
    "title": "Sigenergy Neo 1-fase 12 kWh",
    "capacity": "12 kWh opslag · 5 kW",
    "phase": "Voor een 1-faseaansluiting",
    "included": "Neo batterij, controller, sensor en grondmontagekit"
  },
  "neo-1f-14": {
    "title": "Sigenergy Neo 1-fase 14 kWh",
    "capacity": "14 kWh opslag · 5 kW",
    "phase": "Voor een 1-faseaansluiting",
    "included": "Neo batterij, controller, sensor en grondmontagekit"
  },
  "neo-3f-6": {
    "title": "Sigenergy Neo 3-fase 6 kWh",
    "capacity": "6 kWh opslag · 3 kW",
    "phase": "Voor een 3-faseaansluiting",
    "included": "Neo batterij, controller, sensor en grondmontagekit"
  },
  "neo-3f-8": {
    "title": "Sigenergy Neo 3-fase 8 kWh",
    "capacity": "8 kWh opslag · 4 kW",
    "phase": "Voor een 3-faseaansluiting",
    "included": "Neo batterij, controller, sensor en grondmontagekit"
  },
  "neo-3f-12": {
    "title": "Sigenergy Neo 3-fase 12 kWh",
    "capacity": "12 kWh opslag · 10 kW",
    "phase": "Voor een 3-faseaansluiting",
    "included": "Neo batterij, controller, sensor en grondmontagekit"
  },
  "neo-3f-14": {
    "title": "Sigenergy Neo 3-fase 14 kWh",
    "capacity": "14 kWh opslag · 8 kW",
    "phase": "Voor een 3-faseaansluiting",
    "included": "Neo batterij, controller, sensor en grondmontagekit"
  },
  "neo-3f-16": {
    "title": "Sigenergy Neo 3-fase 16 kWh",
    "capacity": "16 kWh opslag · 8 kW",
    "phase": "Voor een 3-faseaansluiting",
    "included": "Neo batterij, controller, sensor en grondmontagekit"
  },
  "neo-3f-20": {
    "title": "Sigenergy Neo 3-fase 20 kWh",
    "capacity": "20 kWh opslag · 10 kW",
    "phase": "Voor een 3-faseaansluiting",
    "included": "Neo batterij, controller, sensor en grondmontagekit"
  },
  "neo-3f-24": {
    "title": "Sigenergy Neo 3-fase 24 kWh",
    "capacity": "24 kWh opslag · 12 kW",
    "phase": "Voor een 3-faseaansluiting",
    "included": "Neo batterij, controller, sensor en grondmontagekit"
  },
  "neo-3f-26": {
    "title": "Sigenergy Neo 3-fase 26 kWh",
    "capacity": "26 kWh opslag · 15 kW",
    "phase": "Voor een 3-faseaansluiting",
    "included": "Neo batterij, controller, sensor en grondmontagekit"
  }
});

  class TSLPackageQuiz extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.form = this.querySelector('[data-quiz-form]');
      this.result = this.querySelector('[data-quiz-result]');
      this.progress = this.querySelector('[data-quiz-progress]');
      this.progressBar = this.querySelector('[data-progress-bar]');
      this.progressLabel = this.querySelector('[data-progress-label]');
      this.navigation = this.querySelector('[data-quiz-navigation]');
      this.backButton = this.querySelector('[data-quiz-back]');
      this.nextButton = this.querySelector('[data-quiz-next]');
      this.nextLabel = this.querySelector('[data-next-label]');
      this.error = this.querySelector('[data-quiz-error]');
      this.offer = this.querySelector('[data-result-offer]');
      this.manual = this.querySelector('[data-result-manual]');
      this.buyButton = this.querySelector('[data-result-buy]');
      this.buyStatus = this.querySelector('[data-result-buy-status]');
      this.installationFields = this.querySelector('[data-result-installation]');
      this.p1Option = this.querySelector('[data-result-p1-option]');
      this.ownP1 = this.querySelector('[data-result-own-p1]');
      this.serviceOption = this.querySelector('[data-result-service-option]');
      this.withInstallation = this.querySelector('[data-result-with-installation]');
      this.personalHelp = this.querySelector('[data-personal-help]');
      this.products = this.readProducts();
      this.surveyUrl = this.dataset.surveyUrl || '';
      this.currentScreen = 'route';
      this.route = '';
      this.recommendation = null;

      if (!this.form) return;

      this.querySelectorAll('[data-quiz-route]').forEach((button) => {
        button.addEventListener('click', () => this.chooseRoute(button.dataset.quizRoute));
      });
      this.form.addEventListener('change', () => this.handleChange());
      this.backButton?.addEventListener('click', () => this.goBack());
      this.nextButton?.addEventListener('click', () => this.goForward());
      this.querySelector('[data-quiz-restart]')?.addEventListener('click', () => this.restart());
      this.querySelector('[data-view-all]')?.addEventListener('click', () => this.showAllOptions());
      this.buyButton?.addEventListener('click', () => this.buyRecommendation());
      this.ownP1?.addEventListener('change', () => this.switchP1Package());
      this.querySelector('[data-result-postcode]')?.addEventListener('input', () => {
        const postcode = this.querySelector('[data-result-postcode]');
        if (postcode.value.trim().length >= 4) this.clearPostcodeError();
      });
      this.querySelectorAll('[data-result-service-mode]').forEach((input) => input.addEventListener('change', () => {
        if (!this.recommendation?.key.startsWith('neo-')) return;
        this.recommendation.mode = input.value;
        this.renderOffer(PACKAGES[this.recommendation.key]);
        this.publishRecommendation(false);
        this.saveHistory('replace');
      }));
      this.personalHelp?.addEventListener('click', () => {
        this.track('personal_advice_clicked', { destination: this.personalHelp.getAttribute('href') });
      });

      this.historyReady = false;
      this.onHistoryChange = (event) => this.restoreHistory(event.state?.tslQuiz);
      window.addEventListener('popstate', this.onHistoryChange);
      const saved = window.history.state?.tslQuiz;
      this.showScreen('route');
      this.historyReady = true;
      if (saved?.id === this.id) this.restoreHistory(saved);
      else this.saveHistory('replace');
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.onHistoryChange);
      delete this.dataset.initialized;
    }

    saveHistory(method = 'push') {
      if (!this.historyReady || this.restoringHistory) return;
      const state = {
        id: this.id, screen: this.currentScreen, route: this.route,
        phase: this.value('phase'), usage: this.value('usage'),
        recommendation: this.recommendation,
        manual: this.manualCopy || null,
      };
      window.history[`${method}State`]({ ...window.history.state, tslQuiz: state }, '');
    }

    restoreHistory(state) {
      if (!state || state.id !== this.id) return;
      this.restoringHistory = true;
      try {
        this.route = state.route;
        this.recommendation = state.recommendation;
        this.form.querySelectorAll('input[name="phase"], input[name="usage"]').forEach((input) => {
          input.checked = input.value === state[input.name];
        });
        if (state.screen === 'result' && state.recommendation) this.showResult();
        else if (state.screen === 'manual' && state.manual) this.showManualResult(state.manual.heading, state.manual.reason);
        else this.showScreen(['route', 'phase', 'usage'].includes(state.screen) ? state.screen : 'route');
      } finally {
        this.restoringHistory = false;
      }
    }

    chooseRoute(route) {
      this.route = route;
      this.hideError();
      this.track('route_selected', { selected_route: route });

      if (route === 'self' || route === 'samduo') {
        this.recommendation = {
          key: route === 'samduo' ? 'samduo' : 'marstek-p1',
          mode: 'self',
        };
        this.showResult();
        return;
      }

      this.track('step_progressed', { from_step: 'route', to_step: 'phase' });
      this.showScreen('phase');
    }

    handleChange() {
      this.saveHistory('replace');
      this.hideError();
      if (this.nextButton) this.nextButton.disabled = !this.hasAnswer();
    }

    hasAnswer() {
      const name = this.currentScreen === 'phase' ? 'phase' : 'usage';
      return Boolean(this.value(name));
    }

    goForward() {
      if (!this.hasAnswer()) {
        this.showError();
        return;
      }

      if (this.currentScreen === 'phase') {
        if (this.value('phase') === 'unknown') {
          this.track('step_progressed', { from_step: 'phase', to_step: 'manual_result', answer: 'unknown' });
          this.showManualResult('We controleren uw meterkast graag', 'Zonder te weten of u een 1-fase- of 3-faseaansluiting heeft, willen we geen pakket voor u gokken.');
          return;
        }
        this.track('step_progressed', { from_step: 'phase', to_step: 'usage', answer: this.value('phase') });
        this.showScreen('usage');
        return;
      }

      this.recommendation = this.calculateInstalledRecommendation();
      if (this.recommendation.manual) {
        this.track('step_progressed', { from_step: 'usage', to_step: 'manual_result', answer: this.value('usage') });
        this.showManualResult(this.recommendation.heading, this.recommendation.reason);
        return;
      }
      this.track('step_progressed', { from_step: 'usage', to_step: 'recommendation', answer: this.value('usage') });
      this.showResult();
    }

    goBack() {
      if (this.historyReady && window.history.state?.tslQuiz?.id === this.id && this.currentScreen !== 'route') {
        window.history.back();
        return;
      }
      if (this.currentScreen === 'usage') this.showScreen('phase');
      else this.showScreen('route');
    }

    showScreen(screen) {
      this.currentScreen = screen;
      this.result.hidden = true;
      this.form.hidden = false;
      this.progress.hidden = false;
      this.navigation.hidden = screen === 'route';

      this.querySelectorAll('[data-quiz-screen]').forEach((fieldset) => {
        const visible = fieldset.dataset.quizScreen === screen;
        fieldset.hidden = !visible;
        fieldset.disabled = !visible;
      });

      const progressStep = screen === 'route' ? 1 : screen === 'phase' ? 2 : 3;
      this.progress.setAttribute('aria-valuenow', String(progressStep));
      this.progressLabel.textContent = `Stap ${progressStep} van 3`;
      this.progressBar.style.width = `${(progressStep - 1) * 50}%`;
      if (this.nextLabel) this.nextLabel.textContent = screen === 'usage' ? 'Bekijk mijn advies' : 'Verder';
      if (this.nextButton) this.nextButton.disabled = !this.hasAnswer();
      this.hideError();

      this.saveHistory();
      if (screen !== 'route') {
        this.querySelector(`[data-quiz-screen="${screen}"] legend`)?.focus({ preventScroll: true });
      }
    }

    calculateInstalledRecommendation() {
      const phase = this.value('phase');
      const usage = this.value('usage');

      if (!['one', 'three'].includes(phase) || usage === 'unknown') {
        return { manual: true, heading: 'Samen de juiste capaciteit bepalen', reason: 'We bekijken uw verbruik en aansluiting voordat we een pakket adviseren.' };
      }
      if (phase === 'one' && usage === 'very-high') {
        return { manual: true, heading: 'Eerst uw aansluiting en verbruik controleren', reason: 'Ons 1-fase Neo aanbod loopt tot 14 kWh en 5 kW. Bij dit verbruik bekijken we samen of dat past of dat een andere aansluiting nodig is.' };
      }
      const capacities = phase === 'one'
        ? { low: 6, standard: 8, large: 12, high: 14 }
        : { low: 6, standard: 8, large: 16, high: 20, 'very-high': 26 };
      if (!capacities[usage]) return { manual: true, heading: 'Vraag persoonlijk advies', reason: 'We helpen u een passende batterij te kiezen.' };
      return {
        key: `neo-${phase === 'one' ? '1f' : '3f'}-${capacities[usage]}`,
        mode: 'installed',
      };
    }

    showResult() {
      const details = PACKAGES[this.recommendation?.key];
      if (!details) return;

      this.currentScreen = 'result';
      this.saveHistory();
      this.form.hidden = true;
      this.progress.hidden = true;
      this.manual.hidden = true;
      this.result.hidden = false;
      this.offer.hidden = false;
      this.querySelector('[data-result-heading]').hidden = true;
      this.querySelector('[data-result-reason]').hidden = true;
      this.renderOffer(details);
      this.publishRecommendation(false);
      this.track('recommendation_shown', {
        package_key: this.recommendation.key,
        recommendation_mode: this.recommendation.mode,
      });
      this.querySelector('[data-result-product-title]')?.focus({ preventScroll: true });
    }

    showManualResult(heading, reason) {
      this.recommendation = null;
      this.currentScreen = 'manual';
      this.manualCopy = { heading, reason };
      this.saveHistory();
      this.form.hidden = true;
      this.progress.hidden = true;
      this.offer.hidden = true;
      this.manual.hidden = false;
      this.result.hidden = false;
      const resultHeading = this.querySelector('[data-result-heading]');
      const resultReason = this.querySelector('[data-result-reason]');
      resultHeading.hidden = false;
      resultReason.hidden = false;
      resultHeading.textContent = heading;
      resultReason.textContent = reason;
      this.track('manual_result_shown');
      resultHeading.focus({ preventScroll: true });
    }

    readProducts() {
      try {
        return JSON.parse(this.querySelector('[data-quiz-products]')?.textContent || '{}');
      } catch (error) {
        console.error('De producten voor de pakketkeuze konden niet worden gelezen.', error);
        return {};
      }
    }

    renderOffer(details) {
      const product = this.products[this.recommendation.key];
      const installed = this.recommendation.mode === 'installed';
      const choosing = this.recommendation.mode === 'choose';
      const ready = product && (!installed || (product.installation && product.kit));
      const available = !choosing && ready && product.available
        && (!installed || (product.installation.available && product.kit.available));

      this.installationFields.hidden = !installed;
      this.p1Option.hidden = !this.recommendation.key.startsWith('marstek-');
      this.serviceOption.hidden = !this.recommendation.key.startsWith('neo-');
      this.withInstallation.checked = installed;
      this.querySelectorAll('[data-result-service-mode]').forEach((input) => {
        input.checked = input.value === this.recommendation.mode;
      });
      this.querySelector('[data-result-vat-disclaimer]').hidden = !installed || !ready;
      if (this.ownP1) this.ownP1.checked = this.recommendation.key === 'marstek-no-p1';
      const neo = this.recommendation.key.startsWith('neo-');
      this.querySelector('[data-result-product-title]').textContent = neo ? 'SigenStor Neo' : this.recommendation.key.startsWith('marstek-') ? 'Marstek Venus-E 3.0' : details.title || product?.title || 'Thuisbatterijpakket';
      this.querySelector('[data-result-neo-details]').hidden = !neo;
      this.querySelector('[data-result-after-order]').hidden = !installed;
      this.querySelector('[data-result-price]').textContent = installed
        ? (ready ? product.totalPriceFormatted : 'Prijs tijdelijk niet beschikbaar')
        : (product ? product.priceFormatted : 'Prijs tijdelijk niet beschikbaar');
      this.querySelector('[data-result-total-note]').textContent = choosing ? '' : installed ? 'Inclusief btw en standaardinstallatie. Zonder aangesloten noodstroom.' : neo ? 'Inclusief btw. Installatie en overige materialen niet inbegrepen.' : 'Inclusief btw.';
      this.querySelector('[data-result-price-ex]').textContent = installed
        ? (ready ? `Circa ${product.recoveryEstimateFormatted} na eventuele btw-teruggaaf` : '')
        : '';
      if (choosing) {
        this.querySelector('[data-result-price]').textContent = 'Kies hieronder uw uitvoering';
        this.querySelector('[data-result-price-ex]').textContent = '';
      }
      this.querySelector('[data-result-capacity]').textContent = details.capacity;
      this.querySelector('[data-result-phase]').textContent = details.phase.replace('Voor een ', '').replace('aansluiting', '');
      this.querySelector('[data-result-included]').textContent = installed
        ? 'Neo hardware, materiaalkit en SmartNRG installatie; zonder aangesloten back-up'
        : details.included + (this.recommendation.mode === 'hardware' ? '. Installatie en overige materialen regelt u zelf.' : '');

      const image = this.querySelector('[data-result-image]');
      if (image) {
        const hasImage = Boolean(product?.image);
        image.hidden = !hasImage;
        image.closest('.tsl-package-quiz__offer-product')
          ?.classList.toggle('tsl-package-quiz__offer-product--no-image', !hasImage);
        if (product?.image) {
          image.src = product.image;
          image.alt = product.title;
        }
      }

      this.buyButton.disabled = !available;
      this.buyButton.querySelector('span').textContent = choosing ? 'Kies eerst uw uitvoering' : available ? 'Dit pakket bestellen' : 'Tijdelijk niet beschikbaar';
      this.clearBuyStatus();
    }

    switchP1Package() {
      if (this.route !== 'self' || !this.recommendation) return;
      this.recommendation.key = this.ownP1.checked ? 'marstek-no-p1' : 'marstek-p1';
      const details = PACKAGES[this.recommendation.key];
      this.track('package_option_changed', {
        package_key: this.recommendation.key,
        own_p1_meter: this.ownP1.checked,
      });
      this.renderOffer(details);
      this.publishRecommendation(false);
    }

    async buyRecommendation() {
      const product = this.products[this.recommendation?.key];
      const installed = this.recommendation?.mode === 'installed';
      if (!product || !this.buyButton || this.buyButton.disabled) return;
      if (this.recommendation.mode === 'choose') return;
      if (installed && !this.validateInstallation()) return;

      this.track('add_to_cart_started', {
        package_key: this.recommendation.key,
        recommendation_mode: this.recommendation.mode,
      });

      const packageDetails = PACKAGES[this.recommendation.key];
      const commonProperties = {
        '_TSL pakket': product.title,
        '_Fase': packageDetails.phase,
      };
      const items = [{
        id: product.id,
        quantity: 1,
        properties: {
          ...commonProperties,
          Pakket: product.title,
          Service: installed ? 'Volledig geïnstalleerd' : this.recommendation.mode === 'hardware' ? 'Zelf installatie regelen' : 'Zelf aansluiten',
        },
      }];

      if (installed) {
        const surveyProperty = this.surveyUrl ? { '_Schouwformulier': this.surveyUrl } : {};
        items.push(
          {
            id: product.installation.id,
            quantity: 1,
            parent_id: product.id,
            properties: {
              ...commonProperties,
              '_Pakketonderdeel': 'Installatieservice',
              Installatielocatie: this.querySelector('[data-result-postcode]').value.trim().toUpperCase(),
              Installatievoorwaarden: 'Gelezen en bevestigd',
              ...surveyProperty,
            },
          },
          {
            id: product.kit.id,
            quantity: 1,
            parent_id: product.id,
            properties: { ...commonProperties, '_Pakketonderdeel': 'Installatiekit' },
          },
        );
      }

      const label = this.buyButton.querySelector('span');
      this.buyButton.disabled = true;
      this.buyButton.classList.add('is-loading');
      this.buyButton.setAttribute('aria-busy', 'true');
      label.textContent = 'Wordt toegevoegd…';

      try {
        const response = await fetch(this.dataset.cartAddUrl || '/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.description || payload.message || 'Het pakket kon niet worden toegevoegd.');
        }

        this.setBuyStatus('Pakket toegevoegd. De winkelwagen wordt geopend…', true);
        this.track('add_to_cart_succeeded', {
          package_key: this.recommendation.key,
          recommendation_mode: this.recommendation.mode,
        });
        window.setTimeout(() => window.location.assign(this.dataset.cartUrl || '/cart'), 300);
      } catch (error) {
        this.buyButton.disabled = false;
        this.buyButton.classList.remove('is-loading');
        this.buyButton.removeAttribute('aria-busy');
        label.textContent = 'Dit pakket bestellen';
        this.setBuyStatus(error.message || 'Er ging iets mis. Probeer het opnieuw.', false);
        this.track('add_to_cart_failed', {
          package_key: this.recommendation.key,
          recommendation_mode: this.recommendation.mode,
        });
      }
    }

    clearPostcodeError() {
      this.querySelector('[data-result-postcode]')?.removeAttribute('aria-invalid');
      const error = this.querySelector('[data-result-postcode-error]');
      if (error) error.hidden = true;
    }

    validateInstallation() {
      const postcode = this.querySelector('[data-result-postcode]');
      const conditions = this.querySelector('[data-result-conditions-confirm]');
      if ((postcode?.value.trim() || '').length < 4) {
        this.clearBuyStatus();
        postcode?.setAttribute('aria-invalid', 'true');
        const error = this.querySelector('[data-result-postcode-error]');
        if (error) error.hidden = false;
        postcode?.focus();
        return false;
      }
      this.clearPostcodeError();
      if (!conditions?.checked) {
        this.setBuyStatus('Bevestig dat u de standaard installatievoorwaarden heeft gelezen.', false);
        conditions?.focus();
        return false;
      }
      return true;
    }

    publishRecommendation(scroll) {
      if (!this.recommendation) return;
      document.dispatchEvent(new CustomEvent('tsl:package-recommendation', {
        detail: { ...this.recommendation, scroll: Boolean(scroll) },
      }));
    }

    showAllOptions() {
      this.track('all_packages_clicked', { destination: this.dataset.resultsUrl || `#${this.dataset.tableAnchor}` });
      if (this.dataset.resultsUrl) {
        window.location.assign(this.dataset.resultsUrl);
        return;
      }
      document.dispatchEvent(new CustomEvent('tsl:show-all-packages', {
        detail: { scroll: true },
      }));
    }

    restart() {
      this.track('restarted');
      this.clearPostcodeError();
      this.form.reset();
      this.querySelectorAll('[data-result-postcode], [data-result-conditions-confirm]').forEach((field) => {
        if (field.type === 'checkbox') field.checked = false;
        else field.value = '';
      });
      this.clearBuyStatus();
      this.recommendation = null;
      this.route = '';
      document.dispatchEvent(new CustomEvent('tsl:reset-package-view'));
      this.showScreen('route');
      this.querySelector('[data-quiz-route]')?.focus({ preventScroll: true });
    }

    track(action, details = {}) {
      const payload = {
        quiz_action: action,
        quiz_id: this.id,
        quiz_source: window.location.pathname === '/' ? 'homepage' : 'package_page',
        quiz_screen: this.currentScreen,
        quiz_route: this.route || '',
        ...details,
      };

      this.dispatchEvent(new CustomEvent('tsl:quiz-event', {
        bubbles: true,
        detail: payload,
      }));

      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
          event: `tsl_quiz_${action}`,
          ...payload,
        });
      }
    }

    value(name) {
      return this.form?.querySelector(`[name="${name}"]:checked`)?.value || '';
    }

    showError() {
      this.error.hidden = false;
      this.querySelector(`[data-quiz-screen="${this.currentScreen}"] input`)?.focus();
    }

    hideError() {
      this.error.hidden = true;
    }

    setBuyStatus(message, success) {
      if (!this.buyStatus) return;
      this.buyStatus.textContent = message;
      this.buyStatus.hidden = false;
      this.buyStatus.classList.toggle('is-success', Boolean(success));
    }

    clearBuyStatus() {
      if (!this.buyStatus) return;
      this.buyStatus.textContent = '';
      this.buyStatus.hidden = true;
      this.buyStatus.classList.remove('is-success');
    }
  }

  customElements.define('tsl-package-quiz', TSLPackageQuiz);
})();
